import {Component, Input, OnInit} from '@angular/core';
import {DeviationDefinition} from '../../../domain/deviation-definition';

@Component({
    selector: 'app-deviation-defintion-item',
    templateUrl: './deviation-defintion-item.component.html',
    styleUrls: ['./deviation-defintion-item.component.css'],
    standalone: false
})
export class DeviationDefintionItemComponent implements OnInit {
  @Input() deviationDefinition: DeviationDefinition;

  constructor() {
  }

  ngOnInit(): void {
  }
}
